import React, { useState } from 'react';
import styles from './Navigation.module.css';
import { Container } from '../Container';
import clsx from 'clsx';

interface NavigationProps {
  activeSection?: string;
  onNavigate?: (sectionId: string) => void;
}

const navItems = [
  { id: 'hero', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'portfolio', label: 'Portfolio' },
  { id: 'contact', label: 'Contact' },
];

export const Navigation: React.FC<NavigationProps> = ({ activeSection, onNavigate }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleNavClick = (sectionId: string) => {
    if (onNavigate) {
      onNavigate(sectionId);
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={styles.navigation} aria-label="Main navigation">
      <Container>
        <div className={styles.navContent}>
          {/* Logo */}
          <div className={styles.logo}>
            <span className={styles.logoText}>Dixon App Development</span>
          </div>

          {/* Desktop Menu */}
          <ul className={styles.desktopMenu}>
            {navItems.map((item) => (
              <li key={item.id}>
                <button
                  onClick={() => handleNavClick(item.id)}
                  className={clsx(
                    styles.navLink,
                    activeSection === item.id && styles.active
                  )}
                  aria-current={activeSection === item.id ? 'page' : undefined}
                  aria-label={`Navigate to ${item.label}`}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>

          {/* Mobile Hamburger */}
          <button
            className={styles.hamburger}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isMobileMenuOpen}
            aria-controls="mobile-menu"
          >
            <span className={clsx(styles.hamburgerLine, isMobileMenuOpen && styles.open)} aria-hidden="true" />
            <span className={clsx(styles.hamburgerLine, isMobileMenuOpen && styles.open)} aria-hidden="true" />
            <span className={clsx(styles.hamburgerLine, isMobileMenuOpen && styles.open)} aria-hidden="true" />
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <ul className={styles.mobileMenu} id="mobile-menu">
            {navItems.map((item) => (
              <li key={item.id}>
                <button
                  onClick={() => handleNavClick(item.id)}
                  className={clsx(
                    styles.mobileNavLink,
                    activeSection === item.id && styles.active
                  )}
                  aria-current={activeSection === item.id ? 'page' : undefined}
                  aria-label={`Navigate to ${item.label}`}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        )}
      </Container>
    </nav>
  );
};
